import { getTicketInventoryMatrix } from '../../utilities/api'
import { useEffect, useState } from 'react'
import Stack from 'react-bootstrap/Stack'

import { useReportRefresh } from '../../hooks/useReportRefresh'
import { ReportRefreshButton } from '../ReportRefreshButton'
import MatrixTable from './MatrixTable'

export default function TicketMatrixWrapper({ organization }) {
  const [matrix, setMatrix] = useState({})
  const [isLoadingData, setIsLoadingData] = useState(false)
  const { refreshToken, refresh, completeRefresh } =
    useReportRefresh(isLoadingData)

  useEffect(() => {
    if (!organization?.uuid) return

    setIsLoadingData(true)
    getTicketInventoryMatrix(organization.uuid)
      .then((data) => {
        setMatrix(data.data)
      })
      .catch((err) => console.error(err))
      .finally(() => {
        setIsLoadingData(false)
        completeRefresh()
      })
  }, [organization?.uuid, refreshToken])

  return (
    <>
      <Stack direction="horizontal" gap={3} className="mb-3 align-items-center">
        <ReportRefreshButton
          onRefresh={refresh}
          isRefreshing={isLoadingData}
          disabled={isLoadingData || !organization?.uuid}
        />
      </Stack>
      <MatrixTable matrix={matrix} />
    </>
  )
}
